import { defineMessages } from '../define';

export const contacts = defineMessages({
  en: {
    'contacts.title': 'Contacts',
    'contacts.description': 'People your sessions have exchanged messages with.',
    'contacts.searchPlaceholder': 'Search contacts…',
    'contacts.blockedOnly': 'Blocked only',
    'contacts.blocked': 'Blocked',

    'contacts.column.contact': 'Contact',
    'contacts.column.session': 'Session',
    'contacts.column.statusMessage': 'Status message',
    'contacts.column.messages': 'Messages',
    'contacts.column.lastMessage': 'Last message',

    'contacts.empty.title': 'No contacts yet',
    'contacts.empty.description':
      'A contact is recorded the first time a connected session sees a message from them.',
    'contacts.empty.filtered.title': 'No contacts match these filters',
    'contacts.empty.filtered.description':
      'Try another session, or clear the filters to see everyone.',

    'contacts.sheet.title': 'Contact',
    'contacts.field.status': 'Status',
    'contacts.field.lineId': 'LINE id',
    'contacts.copyLineId': 'Copy LINE id',
    'contacts.lineIdHidden': 'Not exposed by LINE',
    'contacts.recentMessages': 'Recent messages',
    'contacts.noMessages': 'Nothing captured from this contact yet.',
  },
  th: {
    'contacts.title': 'รายชื่อผู้ติดต่อ',
    'contacts.description': 'ผู้คนที่เซสชันของคุณเคยรับส่งข้อความด้วย',
    'contacts.searchPlaceholder': 'ค้นหารายชื่อ…',
    'contacts.blockedOnly': 'เฉพาะที่ถูกบล็อก',
    'contacts.blocked': 'ถูกบล็อก',

    'contacts.column.contact': 'ผู้ติดต่อ',
    'contacts.column.session': 'เซสชัน',
    'contacts.column.statusMessage': 'ข้อความสถานะ',
    'contacts.column.messages': 'ข้อความ',
    'contacts.column.lastMessage': 'ข้อความล่าสุด',

    'contacts.empty.title': 'ยังไม่มีรายชื่อผู้ติดต่อ',
    'contacts.empty.description':
      'ระบบจะบันทึกผู้ติดต่อเมื่อเซสชันที่เชื่อมต่ออยู่เห็นข้อความจากคนนั้นเป็นครั้งแรก',
    'contacts.empty.filtered.title': 'ไม่มีรายชื่อที่ตรงกับตัวกรองนี้',
    'contacts.empty.filtered.description': 'ลองเลือกเซสชันอื่นหรือล้างตัวกรองเพื่อดูทั้งหมด',

    'contacts.sheet.title': 'ผู้ติดต่อ',
    'contacts.field.status': 'สถานะ',
    'contacts.field.lineId': 'LINE id',
    'contacts.copyLineId': 'คัดลอก LINE id',
    'contacts.lineIdHidden': 'LINE ไม่เปิดเผยข้อมูลนี้',
    'contacts.recentMessages': 'ข้อความที่ผ่านมา',
    'contacts.noMessages': 'ยังไม่มีข้อความจากผู้ติดต่อรายนี้',
  },
});
